import React from 'react';
import { Modal, Button, Input, Select } from 'antd';

export type SaveSymbology = 'current' | 'default';

interface LayerPropertiesModalProps {
  visible: boolean;
  onCancel: () => void;
  onSave: () => void;
  layerProps: { name: string; alias: string; symbology?: SaveSymbology };
  setLayerProps: (val: any) => void;
  isLoading: boolean;
}

const LayerPropertiesModal: React.FC<LayerPropertiesModalProps> = ({ visible, onCancel, onSave, layerProps, setLayerProps, isLoading }) => {
  return (
    <Modal
      open={visible}
      title="LAYER PROPERTIES"
      onCancel={onCancel}
      footer={
        <div className="footerContent">
          <Button type="primary" loading={isLoading} onClick={onSave}>
            Save
          </Button>
        </div>
      }
      width={500}
      className="layerPropsModal"
    >
      <div className="inputGroup">
        <div className="fieldRow">
          <label className="fieldLabel">LAYER NAME</label>
          <Input placeholder="Enter Layer Name" value={layerProps.name} onChange={(e) => setLayerProps({ ...layerProps, name: e.target.value })} />
        </div>
        <div className="fieldRow">
          <label className="fieldLabel">ALIAS</label>
          <Input placeholder="Enter Alias" value={layerProps.alias} onChange={(e) => setLayerProps({ ...layerProps, alias: e.target.value })} />
        </div>
        <div className="fieldRow">
          <label className="fieldLabel">SYMBOLOGY</label>
          <Select
            className="symbologySelect"
            value={layerProps.symbology ?? 'current'}
            onChange={(symbology: SaveSymbology) => setLayerProps({ ...layerProps, symbology })}
            options={[
              { label: 'USE CURRENT SYMBOLOGY', value: 'current' },
              { label: 'USE DEFAULT SYMBOLOGY', value: 'default' },
            ]}
          />
        </div>
      </div>
    </Modal>
  );
};

export default LayerPropertiesModal;
